import React, { Component } from "react";
import OtpInput from "react-otp-input";
import "./Login.css";

class OtpCodeInput extends Component {
   constructor(props) {
      super(props);

      this.state = {
         otpCode: "",
         message: "",
      };

      this.handleOtpChange = this.handleOtpChange.bind(this);
      this.handleResendClick = this.handleResendClick.bind(this);
      this.handleVerifyClick = this.handleVerifyClick.bind(this);
   }

   handleOtpChange = (otp) => {
      this.setState({ otpCode: otp });
   };

   handleResendClick = (e) => {
      const { resendOtp, data } = this.props;
      console.log("this.prop:", this.props);
      //this.setState({ otpCode: "" });
      //ここにはthis.setState関数で更新する必要がないで、resendOTPを実行する時に
      //Reducerのデータを必ず変更してRender()を行うためです。
      resendOtp(this.props?.username || (data && data?.login_email), data);

      this.setState({ otpCode: "", message: "送信中" });
   };

   handleVerifyClick = (e) => {
      this.setState({ message: "認証中" });
      const { verifyOtp, data } = this.props;
      verifyOtp(this.state.otpCode, data, this.props?.autologin || false);
   };

   LoadingSpinner = (message) => {
      return (
         <div className="spinner-container">
            {message}
            <span className="loading-spinner"></span>
         </div>
      );
   };

   render() {
      const { isFetching = false } = this.props;
      const { message } = this.state;
      return (
         <div>
            <form name="form" onSubmit={(e) => e.preventDefault()}>
               <div className="otp-group">
                  <div className="otp-title">
                     <p>認証コード</p>
                  </div>
                  <fieldset disabled={isFetching}>
                     <div className="otp-digits">
                        <OtpInput
                           value={this.state.otpCode}
                           numInputs={this.props.otpCodeLength || 6}
                           isInputNum={true}
                           onChange={this.handleOtpChange}
                           inputStyle="inputStyle"
                           separator={<span></span>}
                        />
                     </div>
                     <div>
                        <button
                           className="btn btn-custom signin"
                           onClick={this.handleVerifyClick}
                        >
                           {isFetching === false
                              ? "認証"
                              : this.LoadingSpinner(message)}
                        </button>
                     </div>
                     <div style={{ display: "flex" }}>
                        <button
                           className="btn btn-resend"
                           onClick={this.handleResendClick}
                        >
                           認証コードを再送する
                        </button>
                     </div>
                  </fieldset>
               </div>
               <div>
                  <label
                     className="label-control rounded-0 copyright"
                     style={{ textAlign: "center" }}
                  >
                     © HAKARU PLUS CORPORATION All Right Reserved.
                  </label>
               </div>
            </form>
         </div>
      );
   }
}

export default OtpCodeInput;
